export type ApiEntity = 'Accounts' | 'Contacts' | 'Leads';
export type UserFacingEntity = 'company' | 'person' | 'lead';

export const HOVERVIEW_ORIENTATION = {
    WEST: 'west',
    EAST: 'east',
} as const;

export type HoverviewOrientation =
    (typeof HOVERVIEW_ORIENTATION)[keyof typeof HOVERVIEW_ORIENTATION];

export type Phone = {
    id: string | null;
    numberFormatted: string | null;
    numberFormattedWithCountryCode: string | null;
};
